<template>
  <div class="hello">
    <div class="cephalosome">
      <div class="logo">
        <img style="" @click="logo" src="../assets/logo.png" alt="" />
        <p>创新与知识产权管理人才服务系统</p>
        <!-- <p @click="openLIink">标准推广应用综合服务平台</p> -->
      </div>

      <el-menu :default-active="currentActiveIndex" class="el-menu-vertical-demo tab_ui" mode="horizontal"
        @select="handleSelect">
        <el-menu-item index="51">首页</el-menu-item>
        <el-submenu index="52">
          <template slot="title">资质申请</template>
          <el-menu-item index="64"><template slot="title">
              <!-- <img src="../assets/Innovation.png" alt="" style="width: 15px; height: 15px; margin-right: 10px" /> -->
              <span style="padding-left: 10px;">质量提升辅导人员信息采集</span>
            </template></el-menu-item>
          <!-- <el-menu-item index="62"><template slot="title">
              <img src="../assets/consultanticon.png" alt="" style="width: 15px; height: 15px; margin-right: 10px" />
              <span style="padding-left: 10px;">创新管理咨询师</span>
            </template></el-menu-item><el-menu-item index="63"><template slot="title">
              <img src="../assets/gameicon.png" alt="" style="width: 15px; height: 15px; margin-right: 10px" />
              <span style="padding-left: 10px;">创新管理实训主持人</span>
            </template></el-menu-item> -->
        </el-submenu>
        <el-submenu index="53">
          <template slot="title">资质查询</template>
          <el-menu-item :index="item.code" v-for="(item, index) in arrayText" :key="index"><template slot="title">
              <!-- <img :src="item.icon" alt="" style="width: 15px; height: 15px; margin-right: 10px" /> -->
              <span style="padding-left: 10px;">{{item.value}}</span>
            </template></el-menu-item>
        </el-submenu>
        <el-menu-item index="54">资质维护</el-menu-item>
        <!-- <el-menu-item index="5">资质升级</el-menu-item> -->
        <el-menu-item index="56">学习培训</el-menu-item>
        <el-menu-item index="57">通知公告</el-menu-item>
      </el-menu>
      <!-- <div>
        <el-button type="primary" size="mini" @click="imsppCom" class="aStyle">IMSPP官网</el-button>
      </div> -->
      <div class="tab_Signin" v-if="userss">
        <el-button type="primary" size="mini" @click="imsppCom" class="aStyle">IMSPP官网</el-button>
        <el-button type="text" @click="Signin">登录
        </el-button>
        <!-- <span></span> -->
        <el-button type="primary" round size="mini" @click="register">注册
        </el-button>
      </div>
      <p style="" v-else @mouseover="enter" class="pt" @mouseout="leave">
        <el-button type="primary" size="mini" @click="imsppCom" class="aStyle">IMSPP官网</el-button>
        <span @click="dcs" style="cursor: pointer"> 退出</span> &nbsp;{{
          user_name
        }}
        <img style="cursor: pointer; width: 50px; height: 50px; border-radius: 50%" :src="imageUrl" @click="goPersonal"
          alt="" v-if="imageUrl != ''" />
        <img src="../assets/userpic.png" alt="" style="cursor: pointer; width: 50px; height: 50px; border-radius: 50%"
          v-else @click="goPersonal" />
      </p>
    </div>
    <el-dialog :visible.sync="dialogVisibles" width="24%" top="30vh" :before-close="handleClose"
      :close-on-click-modal="false">
      <div class="top" style="
          display: flex;
          align-items: center;
          justify-content: center;
          margin: 10px 0;
        ">
        <img src="../assets/inforMation.png" alt="" style="margin-right: 5px; color: #000" /><span>温馨提示</span>
      </div>
      <span style="
          margin-left: 10px;
          margin-top: 20px;
          display: inline-block;
          color: #999999;
          white-space: pre-wrap;
        " v-html="messageTitle"></span>
      <span slot="footer" class="dialog-footer" style="margin-left: 10px">
        <el-button type="primary" @click="dialogVisibles = false" round>我知道了</el-button>
      </span>
    </el-dialog>

    <!-- 创新管理咨询师提示 -->
    <el-dialog :visible.sync="dialogVisibleFlag" width="24%" top="30vh" :show-close="false" :before-close="handleCloses"
      :close-on-click-modal="false">
      <div class="top" style="
          display: flex;
          align-items: center;
          justify-content: center;
          margin: 10px 0;
        ">
        <img src="../assets/inforMation.png" alt="" style="margin-right: 5px; color: #000" /><span>温馨提示</span>
      </div>
      <span style="
          margin-left: 10px;
          margin-top: 20px;
          display: inline-block;
          color: #999999;
          white-space: pre-wrap;
        ">{{ msgInfo }}</span>
      <span slot="footer" class="dialog-footer" style="margin-left: 10px">
        <el-button type="primary" @click="dialogVisibleFlag = false" round>我知道了</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  loginOut,
  getDictInfoNews,
  getAreaTime,
  userInfo,
  preCheck,
} from "@/api/api.js";
export default {
  inject: ["reload"],
  name: "again",
  components: {},
  data() {
    return {
      tc: false,
      list: [],
      user: true,
      userss: false,
      outUser: false,
      user_name: "",
      saveAllList: "",
      // activeindex: "",
      
      arrayText: [],
      imageUrl: "",
      dialogVisibles: false,
      messageTitle: "",
      dialogVisibleFlag: false,
      msgInfo: "",
      dictPromise:''
    };
  },
  computed: {
    // 关键优化：通过计算属性获取当前激活的索引
    currentActiveIndex() {
      // 1. 优先从sessionStorage获取
      const storedIndex = sessionStorage.getItem('index');
      if (storedIndex) return storedIndex;
      
      // 2. 其次从路由推断（可选，根据实际路由设计调整）
      return this.getIndexFromRoute();
    }
  },
  async created() {
    this.dictPromise = getDictInfoNews("ZZLXS");
    
    // 获取借阅历史
    this.getList();
    this.users();
    
    var user = JSON.parse(sessionStorage.getItem("user"));
    if (user != "" && user != undefined && user != null) {
      this.userss = false;
      this.outUser = true;
      let baseUrl = window.global_config.BASE_URL;
      userInfo({ id: user.id }).then((res) => {
        if (res.code == 1000 && res.data.photoPath != "") {
          this.imageUrl = "";
          this.imageUrl =
            `${baseUrl}/v1/api/file/${res.data.photoPath}/view` +
            `?${Math.round(Math.random() * 100)}`;
        }
      });
    } else {
      this.userss = true;
      this.outUser = false;
    }
  },
  async mounted() {

    const res = await this.dictPromise;
    if(res.code == 1000) {
      this.arrayText = res.data;
    }
    const storedIndex = sessionStorage.getItem('index');
    if (storedIndex) {
      this.handleIndexNavigation(storedIndex);
    }
  },
  watch: {
    "$store.state.imgUrl"(newVal) {
      this.imageUrl = "";
      if (newVal) {
        let baseUrl = window.global_config.BASE_URL;
        this.imageUrl =
          `${baseUrl}/v1/api/file/${newVal}/view` +
          `?${Math.round(Math.random() * 100)}`;
      } else {
        this.imageUrl = "";
      }
    },
    // 监听路由变化，同步更新选中状态
    $route() {
      const index = this.getIndexFromRoute();
      if (index) {
        sessionStorage.setItem('index', index);
      }
    }
  },
  methods: {
     // 关键优化：从路由推断索引（根据实际路由配置调整）
    getIndexFromRoute() {
      switch (this.$route.name) {
        case 'index': return '51';
        case 'Enterpriseinformations': return '64';
        case 'consultant': return '62';
        case 'gameMaster': return '63';
        case 'upgrade': return ['54', '56'].includes(sessionStorage.getItem('index')) 
          ? sessionStorage.getItem('index') 
          : '54';
        case 'Rotation': return '57';
        case 'Inspection': return this.$route.query.type || '';
        default: return '';
      }
    },
    // 处理学习培训导航
    handleTrainingNavigation() {
    
      if (sessionStorage.getItem("token")) {
        window.open(
          `https://training.imspp.org.cn/#/index?ciphertext=${sessionStorage.getItem("token")}`
        );
      } else {
        window.open(`https://training.imspp.org.cn/#/index`);
        // window.open(`https://edu.imspp.net/#/index`);
      }
      // 跳转前重置导航状态
      this.activeindex = '51';
      sessionStorage.setItem("index", '51');
      this.$store.state.indexActive = '51';
      this.$router.go(0)
    },
    // 判断状态等-是否可以进行采集
    getFlag() {
      if (this.activeindex == "62") {
        // 咨询师
        preCheck(this.$qs.stringify({ userType: "1", cerType: '5' })).then((res) => {
          this.msgInfo = res.msg;
          if (res.code != "1000" && !res.data) {
            this.dialogVisibleFlag = true;
          } else {
            if (res.data) {
              let data = res.data;
              this.$router.push({
                name: "consultant",
                query: { id: this.activeindex, userInfos: data.id, operStep: data.operStep },
              });
            } else {
              this.$router.push({
                name: "consultant",
                query: { id: this.activeindex },
              });
            }
          }
        });
      } else if (this.activeindex == "63") {
        preCheck(this.$qs.stringify({ userType: "2", cerType: '6' })).then((res) => {
          this.msgInfo = res.msg;
          if (res.code != "1000" && !res.data) {
            this.dialogVisibleFlag = true;
          } else {
            if (res.data) {
              let data = res.data;
              this.$router.push({
                name: "gameMaster",
                query: {
                  id: this.activeindex, userInfos: data.id, operStep: data.operStep
                },
              });
            } else {
              this.$router.push({
                name: "gameMaster",
                query: {
                  id: this.activeindex,
                },
              });
            }

          }
        });
      }
    },
    // imspp官网跳转
    imsppCom() {
      window.open(`https://www.imspp.org.cn`);
    },
    handleClose() {
      this.dialogVisibles = false;
    },
    handleCloses() {
      this.dialogVisibleFlag = false;
    },
    goPersonal() {
      this.$store.state.indexActive = "";
      sessionStorage.removeItem("index");
      this.$router.push({ name: "personalCenter" });
    },
   // 关键优化：统一处理索引导航逻辑
    handleIndexNavigation(index,types) {
      const value = sessionStorage.getItem("user");
      switch (index) {
        case '51':
          this.$router.push({ name: "index" });
          break;
        case '62':
        case '63':
          if (value) {
            this.activeindex = index; // 临时赋值用于getFlag
            this.getFlag();
          } else {
            sessionStorage.removeItem("index");
            this.$router.push({ name: "Signin" });
          }
          break;
        case '64':
          getAreaTime().then(response => {
            if (response.code === 1000) {
              if (!response.data.boolean) {
                this.dialogVisibles = true;
                this.messageTitle = response.data.resultMsg;
              } else {
                this.$router.push({ name: "Enterpriseinformations" });
              }
            }
          });
          break;
        case '54':{
          this.$router.push({ name: "upgrade" });
          break;
        }
        case '56':{
          // 学习培训特殊处理 - 跳转到外部项目
          this.handleTrainingNavigation();
          break;
        }
          
        case '57':{
          this.$router.push({ name: "Rotation" });
          break;
        }
        default:{
          console.log(index)
          // 处理资质查询子菜单
          const clickedItem = this.arrayText.find(item => item.code === index);
          console.log(clickedItem)
          if (clickedItem) {
            if (value) {
              this.$router.push({
                name: "Inspection",
                query: { name: clickedItem.value, type: clickedItem.code }
              });
              if(types==1){
                 // 强制刷新页面
                 this.$router.go(0);
              }
            } else {
              sessionStorage.removeItem("index");
              this.$router.push({ name: "Signin" });
            }
          }
        }
          
      }
    },

    // 其他方法保持不变，仅修改handleSelect
    handleSelect(key) {
      // 关键优化：存储选中状态到sessionStorage
      sessionStorage.setItem('index', key);
      
      // 清除无关存储
      sessionStorage.removeItem("ids");
      sessionStorage.removeItem("paramsId");
      sessionStorage.removeItem("qualType");
      sessionStorage.removeItem('userInfoid');
      
      // 执行导航
      this.handleIndexNavigation(key,1);
    },
    leave() {
      this.tc = false;
    },
    enter() {
      this.tc = true;
    },
    users() {
      var userJsonStr = sessionStorage.getItem("user");
      let userEntity = JSON.parse(userJsonStr);

      this.user = true;
      this.userss = false;
      if (userJsonStr != "" && userJsonStr != undefined) {
        this.user = false;
        this.userss = true;
        this.user_name = userEntity.user_name;
      }
    },

    logo() {
      sessionStorage.setItem("index", 51);
      this.$router.push({ name: "index" });
    },
    dcs() {
      // console.log("1111");
      var value = sessionStorage.getItem("user");
      //  let client_id = sessionStorage.getItem("client_id");
      //  let creditCode =  sessionStorage.getItem("creditCode");
      // let code =  sessionStorage.getItem("code");
      //  let content =  sessionStorage.getItem("content");
      sessionStorage.removeItem("index");
      sessionStorage.removeItem("paramsId");
      sessionStorage.removeItem("qualType");
      sessionStorage.removeItem("activeindex");
      let ciphertext = sessionStorage.getItem("ciphertext");
      let publicKey = sessionStorage.getItem("publicKey");

      let token = JSON.parse(value);
      let data = { Authorization: token };
      loginOut(data)
        .then((res) => {
          if (res.code == 1000) {
            this.$router.push({ name: "Signin" });
            this.user = true;
            this.userss = false;
            sessionStorage.removeItem("user");
            sessionStorage.removeItem("passwd");
            sessionStorage.removeItem("token");
            sessionStorage.clear();

            if (ciphertext != null && publicKey != null) {
              sessionStorage.setItem("ciphertext", ciphertext);
              sessionStorage.setItem("publicKey", publicKey);
              // sessionStorage.setItem("client_id",client_id)
              //  sessionStorage.setItem("creditCode",creditCode)
              //   sessionStorage.setItem("code",code)
              //    sessionStorage.setItem("content",content)
              // this.reloads()
            }
          }
        })
        .catch(() => { });
    },

    Newsconsultation() {
      this.$router.push({ name: "Rotation", query: { id: "1" } });
    },
    Signin() {
      sessionStorage.removeItem("index");
      this.$router.push({ name: "Signin" });

      //  const kv =this.$store.state.saveAllList.split("&")
      //           console.log(kv)
      //   const list = []
      //   for(var i=0;i<kv.length;i++){
      //     console.log(  kv[1].split("=")[0])
      //     if(  kv[1].split("=")[0] === 'creditCode'){
      //          const value = kv[i].split("=")[1]
      //     list.push(value)
      //     }

      //   }

      //    if(list.length !=0){
      //       // console.log(list)
      //       sessionStorage.setItem('client_id',list[0])
      //        sessionStorage.setItem('creditCode',list[1])
      //         sessionStorage.setItem('code',list[2])
      //          sessionStorage.setItem('content',list[3])

      //    }
    },
    register() {
      sessionStorage.removeItem("index");
      this.$router.push({ name: "register" });
    },
    // home(index) {
    //   this.activeindex = index;
    //   this.$router.push({ name: "index" });
    // },
    // homeindex(index) {
    //   this.activeindex = index;
    //   this.$router.push({ name: "centerindex" });
    // },
    getList() {
      var value = sessionStorage.getItem("user");
      let values = JSON.parse(value);
      if (values == null) {
        this.userss == false;
        this.user == true;
      }
    },
    openLIink() {
      this.$router.push({ name: "centerindex" });
    },
  },
};
</script>

<style lang="less" scoped>
.h3 {
  cursor: pointer;
}

::v-deep .el-dialog {
  border-radius: 5px;
}

::v-deep .el-dialog__footer {
  text-align: center;
}

.cephalosome {
  // width: 100%;
  // box-sizing: border-box;
  // position: relative;
  height: 80px;
  line-height: 80px;
  width: 100%;
  padding: 0 54px;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: fixed;
  top: 0;
  background: #fff;
  z-index: 99;
  box-shadow: 0px 0px 3px 0 #f0f0f0;
  // box-sizing: border-box;
  font-family: "Helvetica Neue";

  .logo {
    // position: absolute;
    // left: 0;
    // width: 30%;
    height: 80px;
    line-height: 80px;
    font-weight: bold;
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    font-size: 19px;
    color: rgb(38, 38, 39);

    img {
      width: 90px;
      height: 60px;
      background-size: 100%;
    }

    p {
      // cursor: pointer;
      line-height: 25px;
      max-width: 380px;
      min-width: 180px;
      text-align: center;
      // margin-left: 15px;
    }
  }
}

.tc {
  cursor: pointer;
  position: absolute;
  right: 30px;
  bottom: -70px;
  height: 80px;
  width: 80px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #fff;
}

.active {
  color: #fff !important;
  background: rgb(0, 150, 255) !important;
  cursor: pointer;
}

.pt {
  // cursor: pointer;
  height: 100%;
  width: 20%;
  font-size: 16px;
  display: flex;
  align-items: center;
  justify-content: right;
  margin-right: 5px;
}
.aStyle{
  margin-right:20px;
}
.aStyle a{
  color: #fff;
  text-decoration: none;
}
.aStyle {
  margin-right: 40px;
}

.aStyle a {
  color: #fff;
  text-decoration: none;
}

.tab_Signin {
  width: 20%;
  font-size: 16px;
  display: flex;
  justify-content: right;
  align-items: center;
  // margin-right: 5px;
  color: #000;
  .el-button--text{
    color: #333;
  }
span{
  width: 2px;
  height: 16px;
  background:#525151;
  margin: 0 6px;
  display: inline-block;
}

  .el-button--text {
    color: #333;
  }

  span {
    width: 2px;
    height: 16px;
    background: #525151;
    margin: 0 6px;
    display: inline-block;
  }

  .Signin {
    // border: 1px rgb(0, 105, 225) solid;
    border-radius: 3px;
    // color: rgb(0, 105, 225);
    height: 30px;
    width: 60px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 12px;
  }

  .logon {
    margin-left: 10px;
    // border: 1px rgb(0, 105, 225) solid;
    border-radius: 3px;
    // color: rgb(0, 105, 225);
    height: 30px;
    width: 60px;
    // background: rgb(0, 105, 225);
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 12px;
  }
}

.hello {
  height: 100%;
  width: 100%;
  background: #fff;
  color: #000;
}

.Signin:hover {
  cursor: pointer;
}

.logon:hover {
  cursor: pointer;
}

.tab_ui {
  -moz-user-select: none;
  -khtml-user-select: none;
  user-select: none;
  height: 100%;
  width: 50%;
  // margin-left: 510px;
  // background: red;
  display: flex;
  align-items: center;
  line-height: 100%;
  color: #000;
  font-size: 14px;
}

::v-deep.el-menu--horizontal>.el-menu-item {
  color: #000;
}

::v-deep.el-menu--horizontal>.el-menu-item.is-active {
  border-bottom: 5px solid #607fea;
}

::v-deep.el-menu--horizontal>.el-menu-item:hover {
  color: #607fea;
}

::v-deep.el-menu--horizontal>.el-submenu .el-submenu__title {
  color: #000;
}

.logo {
  img {
    cursor: pointer;
    width: 414px;
    height: 28px;
  }
}

.Signindiv {
  margin-left: 170px;
}

.spanSSS {
  width: 20px;
}

::v-deep .el-menu--horizontal>.el-submenu .el-submenu__title {
  height: 80px;
  line-height: 80px;
  font-size: 14px;
}

::v-deep .el-menu--horizontal>.el-menu-item {
  height: 80px;
  line-height: 80px;
  padding: 0 23px;
}

::v-deep .el-menu.el-menu--horizontal {
  border: none;
}

::v-deep .el-dialog__header {
  padding-top: 15px;
}

::v-deep .el-dialog__body {
  text-align: center;
  font-size: 16px;
  padding: 0 20px 20px 20px;
}
</style>
